const usersCollection = 'Users',
  doctorsCollection = 'Doctors',
  profilesCollection = 'Profiles',
  patientsCollection = 'Patients',
  reviewsCollection = 'Reviews',
  healthInstitutionCollection = 'health_institutions',
  wellnessClassSubscriptionsCollection = 'ClassSubscriptions',
  userWellnessPassCollection = 'UserWellnessPass',
  wellnessClassesCollection = 'WellnessClasses',
  consultationsCollection = 'Consultations',
  appointmentsCollections = 'Appointments',
  bookingsCollections = 'Bookings',
  messagesCollection = 'Messages',
  firebaseBaseUrl = process.env.REACT_APP_BASE_URL,
  fireStorageUrl = process.env.REACT_APP_FIRE_STORAGE_BASE

export {
  wellnessClassSubscriptionsCollection,
  userWellnessPassCollection,
  wellnessClassesCollection,
  doctorsCollection,
  patientsCollection,
  profilesCollection,
  reviewsCollection,
  usersCollection,
  healthInstitutionCollection,
  appointmentsCollections,
  consultationsCollection,
  bookingsCollections,
  messagesCollection,
  firebaseBaseUrl,
  fireStorageUrl,
}
